//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IconCancel from '@vip-activity/ui/components/icon/IconCancel.vue';
import config from '@/config';
import HuoMask from '../HuoMask/HuoMask.vue';
export default {
  components: {
    IconCancel: IconCancel,
    HuoMask: HuoMask
  },
  data: function data() {
    return {
      visible: false
    };
  },
  computed: {
    now: function now() {
      return this.$store.state.now;
    }
  },
  methods: {
    refreshState: function refreshState() {
      if (config.ptag === 'zhibo') {
        return;
      }

      if (config.inviteVuid && config.orderid) {
        return;
      }

      if (this.now >= window.setting.直播开始时间 && this.now <= window.setting.直播结束时间) {
        this.visible = true;
      }
    },
    toLive: function toLive() {
      var url = window.setting.直播间地址;
      this.openUrl(url);
    }
  },
  mounted: function mounted() {
    this.refreshState();
  }
};